module.exports = __webpack_public_path__ + "img/green_bg.f29ace54.svg";